import React from 'react';
import '../styles/aspireCTA.css';

const AspireCTA = ({ 
  variant = 'standard', // 'navbar', 'standard', 'card'
  className = '', // Additional custom classes
  style = {}, // Inline styles if needed
  href = 'https://allseasons.propertyserviceportal.com/', // Aspire portal URL
}) => {
  
  // Different content based on variant
  const getContent = () => {
    switch(variant) {
      case 'navbar':
        return {
          text: 'Client Portal',
          icon: null,
          subtext: null
        };
      
      case 'standard':
        return {
          text: 'Aspire Platform',
          icon: '🔗',
          subtext: null
        };
      
      case 'card':
        return {
          text: 'Access Your Client Portal',
          icon: '🏠',
          subtext: 'View updates, schedules & photos',
          description: 'Manage your landscaping projects online with real-time updates, photos, and scheduling through our Aspire platform.'
        };
      
      default:
        return {
          text: 'Client Portal',
          icon: null,
          subtext: null
        };
    }
  };

  const content = getContent();
  const finalClasses = `aspire-cta aspire-cta-${variant} ${className}`.trim();

  // Card variant has different structure
  if (variant === 'card') {
    return (
      <div className={finalClasses} style={style}>
        <div className="aspire-cta-card-header">
          {content.icon && <span className="aspire-cta-icon">{content.icon}</span>}
          <h3 className="aspire-cta-card-title">{content.text}</h3>
        </div>
        <p className="aspire-cta-card-description">{content.description}</p>
        <a 
          href={href}
          className="aspire-cta-card-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>{content.subtext}</span>
          <span className="aspire-cta-arrow">→</span>
        </a>
      </div>
    );
  }

  // Navbar and Standard variants
  return (
    <a 
      href={href}
      className={finalClasses}
      style={style}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="aspire-cta-content">
        {content.icon && (
          <span className="aspire-cta-icon">{content.icon}</span>
        )}
        <span className="aspire-cta-text">{content.text}</span>
        {content.subtext && (
          <span className="aspire-cta-subtext">{content.subtext}</span>
        )}
        {variant === 'standard' && (
          <span className="aspire-cta-arrow">→</span>
        )}
      </div>
    </a>
  );
};

export default AspireCTA;